// externals
import { RSAA } from 'redux-api-middleware';

// libraries
import type { IConfigObj } from '@makemydeal/dr-common-utils';
import { buildFromConfig } from '@makemydeal/dr-common-utils';
import type { RSAACallAction, RSAACallRequest } from '@makemydeal/dr-react-18-wrappers';
import type { OfferType } from '@makemydeal/dr-platform-types';

// consts/enums
import {
    UPDATE_VEHICLE_INFO,
    FETCH_CVI_VEHICLE_FAILURE,
    FETCH_CVI_VEHICLE_REQUEST,
    FETCH_CVI_VEHICLE_SUCCESS,
    SHOW_EDIT_VEHICLE,
    HIDE_EDIT_VEHICLE,
    UPDATE_CVI_PRICING,
    INVENTORY_TYPE_SELECT_CLICKED,
    REQUOTE_AFTER_GUARDED_VEHICLE_SWITCH
} from '../actionTypes/vehicleActionTypes';

export type UpdateVehicleInfoPayload = {
    cost: number;
    retailPrice: number;
    listedPrice?: number;
    invoice: number;
    mileage: number;
};

export const updateVehicleInfo = (payload: UpdateVehicleInfoPayload) => {
    return {
        type: UPDATE_VEHICLE_INFO,
        payload,
        meta: {
            middleware: {
                payment: true
            }
        }
    };
};

export const fetchCviVehiclesResults = (query: string, orgId: string, bffEndpointConfig: IConfigObj): RSAACallAction => {
    const proxyUrl = buildFromConfig(bffEndpointConfig, 'commonOrg');
    const endpoint = `${proxyUrl}/${orgId}/vehicles?vehicleIdentifier=${query}`;

    const request: RSAACallRequest = {
        endpoint,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        types: [FETCH_CVI_VEHICLE_REQUEST, FETCH_CVI_VEHICLE_SUCCESS, FETCH_CVI_VEHICLE_FAILURE]
    };
    return {
        [RSAA]: request
    } as RSAACallAction;
};

export const showEditVehicle = () => {
    return { type: SHOW_EDIT_VEHICLE };
};

export const hideEditVehicle = () => {
    return { type: HIDE_EDIT_VEHICLE };
};

export type CviPricingPayload = {
    cviCost?: number;
    dealCostAtCviFetch?: number;
    cviInvoiceAmount?: number;
    dealInvoiceAtCviFetch?: number;
};

export const updateCviPricing = (payload: CviPricingPayload) => ({
    type: UPDATE_CVI_PRICING,
    payload
});

// Analytics-only click event for the Inventory Type selector (consumed by cdlV3AnalyticsMiddleware).
export const inventoryTypeSelectClicked = () => ({
    type: INVENTORY_TYPE_SELECT_CLICKED
});

/**
 * `includeIncentives: true` is required: without it, `resolveIncludeIncentives` falls through to its
 * restoration-enabled default (false for a plain recalc), so the response's applied-incentive set is
 * treated as "incentives not requested" (`reconcileMergedTermIncentives` -> `preserveUnrequestedTermIncentives`),
 * reverting `appliedIncentiveAmount` back toward the stale value this requote exists to replace (DE770242).
 */
export const requoteAfterGuardedVehicleSwitch = (offerType: OfferType) => ({
    type: REQUOTE_AFTER_GUARDED_VEHICLE_SWITCH,
    meta: {
        middleware: {
            payment: true,
            offerType
        },
        includeIncentives: true
    }
});
